import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";

import Box from "@mui/material/Box";
import { Button, Card, Fab } from "@mui/material";
import FileUploader from "../../../FileUploader";
import AddIcon from "@mui/icons-material/Add";
import RemoveSharpIcon from "@mui/icons-material/RemoveSharp";

import { endpoints } from "../../../../services/apiurl";
import Input from "../../../UI/Input/Input";
import TextAreaInput from "../../../UI/Input/TextAreaInput";
import Multiselect from "multiselect-react-dropdown";
import DeleteIcon from "@mui/icons-material/Delete";

import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var sun = false;
var mon = false;
var tue = false;
var wed = false;
var thu = false;
var fri = false;
var sat = false;

const EditRestDish = () => {
  let history = useHistory();
  let { id } = useParams();
  const [selectAll, setSelectAll] = useState(false);
  // const notify = () => toast.success('Toast Message');
  const handleInputChange = (e, index) => {
    const { name, value, type, checked } = e.target;
    const list = [...inputList];

    if (type === "checkbox") {
      list[index][name] = checked ? 1 : 0;
    } else {
      list[index][name] = type === "number" ? parseInt(value, 10) : value;
    }

    setInputList(list);
  };

  const handleSelectAll = () => {
    const allSelected = !selectAll;
    setSelectAll(allSelected);

    const list = [...inputList];
    list.forEach((day) => {
      for (const key in day) {
        if (key !== "price") {
          day[key] = allSelected ? 1 : 0;
        }
      }
    });

    setInputList(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    //console.log('2', list)

    setInputList(list);
  };

  // handle click event of the Add button
  const handleAddClick = (x) => {
    let index;
    const list = [...inputList];

    for (i in x) {
      if (x[i] === 1) {
        let lii = document.getElementsByClassName(x[i]);
        for (index = 0; index < x.length; ++index) {
          lii[index].setAttribute("disabled", "disabled");
        }
      }
    }
    let ob = [...inputList.values()];
    // console.log(ob)
    let li = [];
    let cc = [];
    for (var i = 0; i < ob.length; i++) {
      // the plainest of array loops
      var obj = ob[i];

      for (var key in obj) {
        if (obj[key] === 1) {
          li.push(key);
        }
        cc[key] = obj[key];
        //   console.log(key, obj[key])
      }
    }

    setInputList([
      ...inputList,

      { sun: 0, mon: 0, tue: 0, wed: 0, thu: 0, fri: 0, sat: 0, price: "" },
    ]);

    return cc;
  };

  // let history = useHistory();
  // let { id } = useParams();

  const [cat, setCat] = useState({
    name: "",
    price: "",
    status: "",
    happy_hour: "",
    special: "",
    sub_cat_id: "",
    tax: "",
    vat: "",
    description: "",
    icon: "",
    image: "",
    start_time: "",
    preparation_time: "",
    type: "",
    end_time: "",
    showLogo: "",
    showImage: "",
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileImage, setSelectedFileImage] = useState(null);
  const [subcatgory, setSubCategory] = useState([]);
  const [loading, setloading] = useState(false);

  const {
    name,
    price,
    status,
    happy_hour,
    special,
    sub_cat_id,
    tax,
    vat,
    description,
    icon,
    image,
    showImage,
    showLogo,
    start_time,
    end_time,
    preparation_time,
    type,
  } = cat;
  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    //console.log(cat);
  };

  useEffect(() => {
    // getDopdownSubCategory();
    getTagsByTagType(1);
    getTagsByTagType(2);
    getTagsByTagType(3);
    getTagsByTagType(4);
    getTagsByTagType(5);
    getTagsByTagType(6);
    getMenuType();
    edit();
  }, []);

  const getDopdownSubCategory = async (cat_id) => {
    await axios
      .post(endpoints.getDopdownSubCategory, { cat_id })
      .then((response) => {
        setSubCategory(response.data.data);
      });
  };
  const getMenuType = async () => {
    await axios.post(endpoints.getMenuType).then((response) => {});
  };

  let [healthOption, setHealthOption] = useState([]);
  let [specialOption, setspecialOption] = useState([]);
  let [allergenOptions, setallergenOptions] = useState([]);

  const getTagsByTagType = async (type) => {
    await axios
      .post(endpoints.getTagsByTagType, { tag_type: type })
      .then((response) => {
        if (type == 3) {
          setHealthOption(response.data.data);
        } else if (type == 4) {
          setspecialOption(response.data.data);
        } else if (type == 5) {
          setallergenOptions(response.data.data);
        } else if (type == 6) {
          setInputList(response.data.price);
        }
      });
  };

  let [healthOptionsSelectedData, sethealthOptionsSelectedData] = useState([]);
  let [allergenOptionsSelectedData, setallergenOptionsSelectedData] = useState(
    []
  );
  let [healthOptionsselectedValues, sethealthOptionsselectedValues] = useState(
    []
  );
  let [allergenOptionsselectedValues, setallergenOptionsselectedValues] =
    useState([]);

  const onHealthSelectd = async (e) => {
    sethealthOptionsSelectedData(e);
  };
  const onHealthRemoved = async (e) => {
    sethealthOptionsSelectedData(e);
  };

  const onAllergiSelectd = async (e) => {
    setallergenOptionsSelectedData(e);
  };
  const onAllergiRemoved = async (e) => {
    setallergenOptionsSelectedData(e);
  };

  const edit = async () => {
    await axios.post(endpoints.editDish, { id: id }).then((response) => {
      // console.log(response.data.price);
      getDopdownSubCategory(response.data.data.cat_id);

      sethealthOptionsselectedValues(response.data.health);
      setallergenOptionsselectedValues(response.data.aller);
      if (response.data.price == "") {
        //console.log(response.data.data.price)
        setInputList([
          {
            sun: 0,
            mon: 0,
            tue: 0,
            wed: 0,
            thu: 0,
            fri: 0,
            sat: 0,
            price: response.data.data.price,
          },
        ]);
      } else {
        setInputList(response.data.price);
      }

      setCat({
        id: response.data.data.id,
        price: response.data.price,
        name: response.data.data.name,
        image: response.data.data.image,
        status: response.data.data.status,
        happy_hour: response.data.data.happy_hour,
        icon: response.data.data.icon,
        description: response.data.data.description,
        special: response.data.data.special,
        sub_cat_id: response.data.data.sub_cat_id,
        tax: response.data.data.tax,
        vat: response.data.data.vat,
        start_time: response.data.data.start_time,
        end_time: response.data.data.end_time,
        preparation_time: response.data.data.preparation_time,
        type: response.data.data.type,
        showLogo: response.data.data.showLogo,
        showImage: response.data.data.showImage,
      });
    });
  };

  const [inputList, setInputList] = useState([JSON.stringify(price)]);

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", name);
    formData.append("price", JSON.stringify(inputList));

    formData.append("tax", tax);
    formData.append("vat", vat);
    formData.append("start_time", start_time);
    formData.append("end_time", end_time);

    formData.append("description", description);
    formData.append("special", special);
    formData.append("sub_cat_id", sub_cat_id);
    formData.append("icon", selectedFile);
    formData.append("image", selectedFileImage);

    formData.append("preparation_time", preparation_time);
    formData.append("type", type);
    formData.append("status", status);
    formData.append("happy_hour", happy_hour);
    formData.append(
      "healthOptionsSelectedData",
      JSON.stringify(healthOptionsSelectedData)
    );
    formData.append(
      "allergenOptionsSelectedData",
      JSON.stringify(allergenOptionsSelectedData)
    );
    formData.append("id", id);
    try {
      const response = await axios.post(endpoints.updateDish, formData);

      setloading(false);
      history.goBack();

      if (response.data && response.data.status === true) {
        toast.success("Dish Update Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during editing dish:", error);
      setloading(false);

      toast.error("Error during editing dish. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const removeImageHandler = async (id, type) => {
    await axios
      .post(endpoints.deleteImageDish, { id, type })
      .then((response) => {});
    window.location.reload();
  };

  return (
    <div className="ui main">
      <h2>Edit Dish</h2>
      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />
            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={status}
              >
                <option value="">Select Status</option>
                <option value="1">Active</option>
                <option value="0">InActive</option>
              </select>
            </div>
            <div className="col col-12">
              {inputList?.map((x, i) => {
                return (
                  <Box sx={{ border: "1px solid grey", mt: 2 }}>
                    <div className="row">
                      <Input
                        id="price"
                        label="Price"
                        type="number"
                        name="price"
                        place="Price"
                        onChange={(e) => handleInputChange(e, i)}
                        requiredInput="required"
                        value={x.price}
                        class="col col-4"
                      />

                      <div className="col col-8">
                        <br />
                        <div className="row">
                          <div className="col-md-1">
                            <p>Sun</p>
                            <input
                              type="checkbox"
                              className="sun"
                              name="sun"
                              value={x.sun}
                              checked={inputList[0].sun === 1}
                              {...(sun === true
                                ? { disabled: "disabled" }
                                : {})}
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </div>

                          <div className="col-md-1">
                            <p>Mon</p>

                            <input
                              type="checkbox"
                              className="mon"
                              id="mon"
                              name="mon"
                              checked={inputList[0].mon === 1}
                              value={x.mon}
                              {...(mon === true
                                ? { disabled: "disabled" }
                                : {})}
                              onChange={(e) => handleInputChange(e, i)}
                            />
                          </div>

                          <div className="col-md-1">
                            <p>Tue</p>
                            <input
                              type="checkbox"
                              className="tue"
                              id="tue"
                              name="tue"
                              value={x.tue}
                              checked={inputList[0].tue === 1}
                              onChange={(e) => handleInputChange(e, i)}
                              {...(tue === true
                                ? { disabled: "disabled" }
                                : {})}
                            />
                          </div>
                          <div className="col-md-1">
                            <p>Wed</p>

                            <input
                              type="checkbox"
                              className="wed"
                              id="wed"
                              name="wed"
                              value={x.wed}
                              checked={inputList[0].wed === 1}
                              onChange={(e) => handleInputChange(e, i)}
                              {...(wed === true
                                ? { disabled: "disabled" }
                                : {})}
                            />
                          </div>
                          <div className="col-md-1">
                            <p>Thur</p>

                            <input
                              type="checkbox"
                              className="thu"
                              id="thu"
                              name="thu"
                              value={x.thu}
                              checked={inputList[0].thu === 1}
                              // {...(inputList.length === i ? {} : {...(x.thu === 1 ? { disabled: "disabled" } : {}) } )}
                              onChange={(e) => handleInputChange(e, i)}
                              {...(thu === true
                                ? { disabled: "disabled" }
                                : {})}
                            />
                          </div>
                          <div className="col-md-1">
                            <p>Fri</p>

                            <input
                              type="checkbox"
                              className="fri"
                              id="fri"
                              name="fri"
                              value={x.fri}
                              checked={inputList[0].fri === 1}
                              onChange={(e) => handleInputChange(e, i)}
                              {...(fri === true
                                ? { disabled: "disabled" }
                                : {})}
                            />
                          </div>
                          <div className="col-md-1">
                            <p>Sat</p>

                            <input
                              type="checkbox"
                              className="sat"
                              id="sat"
                              name="sat"
                              value={x.sat}
                              checked={inputList[0].sat === 1}
                              onChange={(e) => handleInputChange(e, i)}
                              {...(sat === true
                                ? { disabled: "disabled" }
                                : {})}
                            />
                          </div>

                          <div className="col-md-1">
                            <p>All</p>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={selectAll}
                            />
                          </div>

                          {inputList.length - 1 === i && (
                            <div className="col-md-2">
                              <div className="mt-2">
                                <Fab
                                  onClick={() => handleAddClick()}
                                  color="primary"
                                  size="medium"
                                  aria-label="add"
                                >
                                  <AddIcon />
                                </Fab>
                              </div>
                            </div>
                          )}

                          {inputList.length - 1 !== i && (
                            <div className="col-md-2">
                              <div className="mt-2">
                                <Fab
                                  onClick={() => handleRemoveClick(i)}
                                  color="secondary"
                                  size="medium"
                                  aria-label="add"
                                >
                                  <RemoveSharpIcon />
                                </Fab>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <br />
                      {/* </Box> */}
                    </div>
                  </Box>
                );
              })}

              {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
            </div>
          </div>
          <div className="px-1">
            <Box sx={{ border: "1px solid grey", mt: 3, mb: 1, pb: 2 }}>
              <div className="row">
                <div className="col col-4">
                  <label>Happy Hours</label>
                  <select
                    name="happy_hour"
                    className="form-control"
                    onChange={(e) => onInputChange(e)}
                    value={happy_hour}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>

                    <option value="0">InActive</option>
                  </select>
                </div>
                <div className="col col-4">
                  <label>Start Time </label>
                  <select
                    name="start_time"
                    className="form-control"
                    onChange={(e) => onInputChange(e)}
                    value={start_time}
                  >
                    <option value="">Select Start Time</option>
                    <option value="10:00">10:00 AM</option>
                    <option value="10:30">10:30 AM</option>
                    <option value="11:00">11:00 AM</option>
                    <option value="11:30">11:30 AM</option>
                    <option value="12:00">12:00 PM</option>
                    <option value="12:30">12:30 PM</option>
                    <option value="13:00">01:00 PM</option>
                    <option value="13:30">01:30 PM</option>
                    <option value="14:00">02:00 PM</option>
                    <option value="14:30">02:30 PM</option>
                    <option value="15:00">03:00 PM</option>
                    <option value="15:30">03:30 PM</option>
                    <option value="16:00">04:00 PM</option>
                    <option value="16:30">04:30 PM</option>
                    <option value="17:00">05:00 PM</option>
                    <option value="17:30">05:30 PM</option>
                    <option value="18:00">06:00 PM</option>
                    <option value="18:30">06:30 PM</option>
                    <option value="19:00">07:00 PM</option>
                    <option value="19:30">07:30 PM</option>
                    <option value="20:00">08:00 PM</option>
                    <option value="20:30">08:30 PM</option>
                    <option value="21:00">09:00 PM</option>
                    <option value="21:30">09:30 PM</option>
                    <option value="22:00">10:00 PM</option>
                    <option value="22:30">10:30 PM</option>
                  </select>
                </div>
                <div className="col col-4">
                  <label>End Time</label>
                  <select
                    name="end_time"
                    className="form-control"
                    onChange={(e) => onInputChange(e)}
                    value={end_time}
                  >
                    <option value="">Select End Time</option>
                    <option value="10:00">10:00 AM</option>
                    <option value="10:30">10:30 AM</option>
                    <option value="11:00">11:00 AM</option>
                    <option value="11:30">11:30 AM</option>
                    <option value="12:00">12:00 PM</option>
                    <option value="12:30">12:30 PM</option>
                    <option value="13:00">01:00 PM</option>
                    <option value="13:30">01:30 PM</option>
                    <option value="14:00">02:00 PM</option>
                    <option value="14:30">02:30 PM</option>
                    <option value="15:00">03:00 PM</option>
                    <option value="15:30">03:30 PM</option>
                    <option value="16:00">04:00 PM</option>
                    <option value="16:30">04:30 PM</option>
                    <option value="17:00">05:00 PM</option>
                    <option value="17:30">05:30 PM</option>
                    <option value="18:00">06:00 PM</option>
                    <option value="18:30">06:30 PM</option>
                    <option value="19:00">07:00 PM</option>
                    <option value="19:30">07:30 PM</option>
                    <option value="20:00">08:00 PM</option>
                    <option value="20:30">08:30 PM</option>
                    <option value="21:00">09:00 PM</option>
                    <option value="21:30">09:30 PM</option>
                    <option value="22:00">10:00 PM</option>
                    <option value="22:30">10:30 PM</option>
                  </select>
                </div>
              </div>
            </Box>
          </div>
          <div className="row">
            <Input
              id="tax"
              label="Tax"
              type="number"
              name="tax"
              place="Tax"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={tax}
              class="col col-4"
            />
            <Input
              id="vat"
              label="Vat"
              type="number"
              name="vat"
              place="Vat"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={vat}
              class="col col-4"
            />
            <Input
              id="preparation_time"
              label="Preparation Time"
              type="text"
              name="preparation_time"
              place="Preparation Time"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={preparation_time}
              class="col col-4"
            />
          </div>

          <div className="row">
            <div className="col col-4">
              <label>Dish Type </label>
              <select
                name="type"
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={type}
              >
                <option value="0">Select Type</option>
                <option value="1">Veg</option>
                <option value="2">Non-veg</option>
                <option value="3">Egg Only</option>
                <option value="4">SeaFood</option>
              </select>
            </div>
            <div className="col col-4">
              <label>Special </label>
              <select
                name="special"
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={special}
              >
                <option value="">Select Special</option>
                {specialOption.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col col-4">
              <label>Allergens </label>
              <Multiselect
                displayValue="name"
                onKeyPressFn={function noRefCheck() {}}
                onRemove={(e) => onAllergiRemoved(e)}
                onSearch={function noRefCheck() {}}
                onSelect={(e) => onAllergiSelectd(e)}
                options={allergenOptions}
                selectedValues={allergenOptionsselectedValues}
              />
            </div>
          </div>

          <div className="row">
            <div className="col col-4">
              <label>Sub Category </label>

              <select
                name="sub_cat_id"
                className="form-control"
                onChange={(e) => onInputChange(e)}
                value={sub_cat_id}
              >
                <option value="">Select Sub Category</option>
                {subcatgory.map((e, key) => {
                  return (
                    <option key={key} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col col-4">
              <label>Health </label>
              <Multiselect
                displayValue="name"
                onKeyPressFn={function noRefCheck() {}}
                onRemove={(e) => onHealthRemoved(e)}
                onSearch={function noRefCheck() {}}
                onSelect={(e) => onHealthSelectd(e)}
                options={healthOption}
                selectedValues={healthOptionsselectedValues}
              />
            </div>

            <TextAreaInput
              id="description"
              label="Description"
              name="description"
              place="Description"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={description}
              class="col col-4"
            />
          </div>

          <div className="row">
            <div className="col col-6">
              <label>Image</label>

              {showImage ? (
                <div className="mt-3">
                  <img
                    src={image}
                    height="200px"
                    width="200px"
                    className="px-2"
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<DeleteIcon />}
                    onClick={() => removeImageHandler(id, "image")}
                  ></Button>
                </div>
              ) : (
                <FileUploader
                  onFileSelectSuccess={(file) => setSelectedFileImage(file)}
                  onFileSelectError={({ error }) => alert(error)}
                />
              )}
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default EditRestDish;
